import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { MedicalItemTypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemTypeEnum";
import { MedicalItemVitalSign } from "@/Patient/Models/MedicalSummary/MedicalItemVitalSign";
import { ObstetricalCounters } from "@/Patient/Models/MedicalSummary/ObstetricalSummary";
import { PreviousObstetricalPdfResponse } from "@/Patient/Models/ObstetricalFile/PreviousObstetricalPdfResponse";

class ObstetricalFileAction extends AsyncAction {
    public async saveVitalSign(
        vitalSign: MedicalItemVitalSign,
        patientContactFacetId: string,
        patientContactId: string,
        latestVisibleMedicalItemId: string
    ): Promise<{ MedicalItems: MedicalItemVitalSign[], EMRTemplateId: string }> {
        return this.postAsync<{ MedicalItems: MedicalItemVitalSign[], EMRTemplateId: string }>(
            ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign,
            {
                PatientContactFacetId: patientContactFacetId,
                PatientContactId: patientContactId,
                MedicalItem: vitalSign,
                SaveInNewEncounter: false,
                LatestVisibleMedicalItemId: latestVisibleMedicalItemId
            }
        );
    }

    public async removeVitalSign(
        vitalSignId: string,
        encounterId: string,
        latestVisibleMedicalItemId: string
    ): Promise<void> {
        await this.postAsync<null>(
            ServerOperations.Server.Myle_Patient_MedicalItem_DeleteMedicalItem,
            {
                MedicalItemId: vitalSignId,
                MedicalItemType: MedicalItemTypeEnum.VitalSigns,
                EncounterId: encounterId,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestVisibleMedicalItemId
            }
        );
    }

    public async getPreviousObstetricalFilePdfForms(encounterId: string, patientContactFacetId: string): Promise<PreviousObstetricalPdfResponse> {
        return this.postAsync<PreviousObstetricalPdfResponse>(
            ServerOperations.Server.Myle_Patient_MedicalNote_GetPreviousObstetricalPdf,
            {
                EncounterId: encounterId,
                PatientContactFacetId: patientContactFacetId
            }
        );
    }

    public async updateForm<TForm>(encounterId: string, obstetricalFileContributionId: string, form: TForm, obstetricalCounters?: ObstetricalCounters, emrTemplateId?: string): Promise<{ ModificationDate: Date }> {
        return this.postAsync<{ ModificationDate: Date }>(
            ServerOperations.Server.Myle_Patient_MedicalNote_UpdateObstetricalFileForm,
            {
                EncounterId: encounterId,
                ObstetricalFileContributionId: obstetricalFileContributionId,
                Form: JSON.stringify(form),
                ObstetricalCounters: obstetricalCounters,
                EmrTemplateId: emrTemplateId
            }
        );
    }
}

export { ObstetricalFileAction };
